import { EmployerStatus } from './employer.constants';

export const isOrganizationInactive = (status?: string) => Boolean(status) && status !== EmployerStatus.Active;
